import React, { useEffect, useRef } from 'react';
import { useFormikContext } from 'formik';

const errorEntries = (errors, prefix = '') => Object.entries(errors).flatMap(([key, value]) => {
  const name = prefix ? `${prefix}.${key}` : key;
  return typeof value === 'string' ? [[name, value]] : value && typeof value === 'object' ? errorEntries(value, name) : [];
});

export default function BudgetValidationFeedback() {
  const { errors, submitCount, isSubmitting, isValidating } = useFormikContext();
  const summary = useRef(null);
  const handledSubmit = useRef(0);
  const entries = errorEntries(errors);
  const focusField = (name) => {
    const form = summary.current?.closest('form');
    const field = Array.from(form?.elements || []).find(element => element.name === name && element.type !== 'hidden');
    const target = field || summary.current;
    target?.focus({ preventScroll: true });
    target?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  useEffect(() => {
    if (!submitCount || isSubmitting || isValidating || handledSubmit.current === submitCount) return;
    handledSubmit.current = submitCount;
    if (entries.length) focusField(entries[0][0]);
  });

  if (!submitCount || !entries.length) return null;
  return (
    <div className="cc-budget-validation" role="alert" ref={summary} tabIndex={-1}>
      <strong>Please check the highlighted fields before continuing.</strong>
      <ul>{entries.map(([name, message]) => <li key={name}>
        <button type="button" onClick={() => focusField(name)}>{message}</button>
      </li>)}</ul>
    </div>
  );
}
